import React, { useState, useLayoutEffect, useEffect, useRef } from 'react';
import { AddDataBoxButton, AddDataBoxButtonShift, AddDataBoxImg } from '../AddDataBox';
import { TextField, Box, Tab, Modal } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

const CustomMenu = (({
  open,
  handleClose,
  value,
  input,
  setInput,
  quantity,
  setQuantity,
  handleInsertNode,
  handleChange,
  buttonRef,
  successData,
  loadData,
  propdata,
  expand,
  setExpand,
}) => {
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const [isShiftMode, setIsShiftMode] = useState(false);

  const handleKeyDown = (e) => {
    // if (e.key === 'Shift') {
    //     setIsShiftPressed(true);
    //     if (successData && Object.keys(successData).length > 0) {
    //         setIsShiftMode(prev => !prev);
    //     }
    if (e.key === 'Enter') {
      e.preventDefault();
      const currentInput = input.trim();
      if (!currentInput) {
        return;
      }
      else {
        if (value === '1') {
          handleInsertNode('location', isShiftMode, currentInput);
        } else if (value === '2') {
          handleInsertNode('both', isShiftMode, currentInput);
        } else {
          handleInsertNode('item', isShiftMode, currentInput);
        }
      }
    }
  };

  // const handleKeyUp = (e) => {
  //     if (e.key === 'Shift') {
  //         setIsShiftPressed(false);
  //     }
  // };

  // useEffect(() => {
  //     window.addEventListener('keydown', handleKeyDown);
  //     window.addEventListener('keyup', handleKeyUp);
  //     return () => {
  //         window.removeEventListener('keydown', handleKeyDown);
  //         window.removeEventListener('keyup', handleKeyUp);
  //     };
  // }, [value , setIsShiftMode , setIsShiftPressed ]);

  // useEffect(() => {
  //     if (propdata?.locations?.length > 0 || propdata?.items?.length > 0) {
  //         setExpand(true);
  //     }
  // }, [propdata]);

  const handleWrappedClose = () => {
    // setIsShiftMode(false);
    // setIsShiftPressed(false)
    handleClose();
    loadData();
  };

  useLayoutEffect(() => {
    if (!open || !buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const modalHeight = 220;

    let topPosition = rect.bottom;

    if (topPosition + modalHeight > windowHeight) {
      topPosition = rect.top - modalHeight;
    }

    if (topPosition < 0) {
      topPosition = 60;
    }

    setModalPosition({ top: topPosition + window.scrollY, left: rect.left + window.scrollX });
  }, [open, buttonRef]);


  const tooltipText = isShiftMode ? `Press Enter to add under the parent - ( ${successData?.location_description} )` : 'Please press Enterv to add data';


  return (
    <>
      <Modal
        open={open}
        onClose={handleWrappedClose}
        sx={{
          position: "absolute",
          top: modalPosition.top,
          left: modalPosition.left,
          zIndex: 1300,
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent !important",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '20px',
            width: '400px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.4)',
          }}
        >
          <div id="modal-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <p style={{ fontSize: '16px', color: '#BF1D2D', fontWeight: '600' }}>
              {value == '1' ? 'Add Location' : value == '2' ? 'Add Location + Item' : 'Add Item'}
            </p>
            <IconButton onClick={handleWrappedClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>

          <TabContext value={value}>
            <Box sx={{ marginTop: '-10px' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {value === '1' ? (
                        <img src="/images/location.svg" height="20px" width="20px" />
                      ) : (
                        <img src="/images/location-black.svg" height="20px" width="20px" />
                      )}
                      Location
                    </span>
                  }
                  value="1"
                />
                <Tab
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <img src="/images/location-item.svg" height="20px" width="20px" />
                      Location + Item
                    </span>
                  }
                  value="2"
                />
                <Tab
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      {value === '3' ? (
                        <img src="/images/item.svg" height="20px" width="20px" />
                      ) : (
                        <img src="/images/item-black.svg" height="20px" width="20px" />
                      )}
                      Item
                    </span>
                  }
                  value="3"
                />
              </TabList>
            </Box>

            <TabPanel value="1">
              <TextField
                id="outlined-basic"
                label="Add Location"
                variant="outlined"
                size="small"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                // onKeyUp={handleKeyUp}
                sx={{
                  '& .MuiInputBase-root': {
                    height: '40px',
                    width: '300px',
                  },
                  marginTop: '-10px',
                }}
              />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                  {(isShiftMode && successData && Object.keys(successData).length > 0) ? (
                    <Tooltip
                      title={tooltipText}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: '#333',
                            color: '#fff',
                            fontSize: '12px',
                            borderRadius: '8px',
                            padding: '6px 12px',
                            marginLeft: '75px',
                            boxShadow: 3,
                          },
                        },
                        arrow: {
                          sx: {
                            color: '#333',
                          },
                        },
                      }}
                    >
                      <span>
                        <AddDataBoxButtonShift
                          handleClick={() => handleInsertNode('location', true)}
                          buttonText="Create"
                          className="button-class"
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <AddDataBoxButton
                      handleClick={() => handleInsertNode('location', false)}
                      buttonText="Create"
                      className="button-class"
                    />
                  )}
                </div>
              </div>
            </TabPanel>

            <TabPanel value="2">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <TextField
                  id="outlined-basic"
                  label="Add Loc. & Item"
                  variant="outlined"
                  size="small"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                  // onKeyUp={handleKeyUp}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '40px',
                      width: '160px',
                    },
                    marginTop: '-10px',
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Add Qty"
                  className="quantity"
                  variant="outlined"
                  size="small"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  onKeyDown={handleKeyDown}
                  // onKeyUp={handleKeyUp}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '40px',
                      width: '140px',
                    },
                    marginTop: '-10px',
                  }}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                  {(isShiftMode && successData && Object.keys(successData).length > 0) ? (
                    <Tooltip
                      title={tooltipText}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: '#333',
                            color: '#fff',
                            fontSize: '12px',
                            borderRadius: '8px',
                            padding: '6px 12px',
                            marginLeft: '75px',
                            boxShadow: 3,
                          },
                        },
                        arrow: {
                          sx: {
                            color: '#333',
                          },
                        },
                      }}
                    >
                      <span>
                        <AddDataBoxButtonShift
                          handleClick={() => handleInsertNode('both', true)}
                          buttonText="Create"
                          className="button-class"
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <AddDataBoxButton
                      handleClick={() => handleInsertNode('both', false)}
                      buttonText="Create"
                      className="button-class"
                    />
                  )}
                </div>
              </div>
            </TabPanel>
            <TabPanel value="3">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <TextField
                  id="outlined-basic"
                  label="Add Item"
                  variant="outlined"
                  size="small"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      handleInsertNode("item", false);
                    }
                  }}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '40px',
                      width: '160px',
                    },
                    marginTop: '-10px',
                  }}
                />
                <TextField
                  id="outlined-basic"
                  className="quantity"
                  label="Add Qty"
                  variant="outlined"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  size="small"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      handleInsertNode("item", false);
                    }
                  }}
                  sx={{
                    '& .MuiInputBase-root': {
                      height: '40px',
                      width: '140px',
                    },
                    marginTop: '-10px',
                  }}
                />
              </div>
              <div>
                <AddDataBoxButton
                  handleClick={() => handleInsertNode("item", false)}
                  buttonText="Create"
                  className="button-class"
                />
              </div>
            </TabPanel >
          </TabContext >
        </Box >
      </Modal >
    </>
  );
});

export default CustomMenu;
